(function ($, App, Utils, Components) {
  'use strict';

  const logger = new Logger('Forms');

  Components.create('Forms', {

    Selectors: {
      password: '.js-password',
      prizesFiltersForm: '.js-prizes-filters',
      max: '.js-range-max',
      min: '.js-range-min',
      invalidInput: '.is-invalid-input',
      invalidLabel: '.is-invalid-label',
      formErrorMsg: '.form-error',
      selectError: 'select.error'
    },


    bindEvents: function () {
      let _this = this;

      if ($(Components.Forms.Selectors.password).length > 0) {
        $(Components.Forms.Selectors.password).on('click', '.js-forms-action', function () {
          _this.togglePasswordVisibility($(this));
        });
      }

      $(Components.Forms.Selectors.invalidInput).focus(function() {
        const parent =  $(this).closest('div.cell');
        const label = parent.find(Components.Forms.Selectors.invalidLabel);
        const msg =  parent.find(Components.Forms.Selectors.formErrorMsg);

        $(this).removeClass(Components.Forms.Selectors.invalidInput.substring(1));
        label.removeClass(Components.Forms.Selectors.invalidLabel.substring(1));
        msg.remove();
      });

      $(Components.Forms.Selectors.selectError).change(function() {
        $(this).removeClass('error')
        $(this).closest('label').removeClass('error');
      });

		
			// disable submit button
			Utils.disableSubmitButton();


    },
      
    togglePasswordVisibility: ($trigger) => {
      let show = !$trigger.data('show-password');
      $trigger.data('show-password', show);
      let $password = $trigger.siblings('input');
      if ($password.val()) {
        $password.attr('type', show ? 'text' : 'password');
      }
    },

    bindPrizesFiltersForm: () => {

      let $form = $(Components.Forms.Selectors.prizesFiltersForm);
      let $inputs = $(`${Components.Forms.Selectors.prizesFiltersForm} input, ${Components.Forms.Selectors.prizesFiltersForm} select`);

      Components.off('customrange:change').on('customrange:change', (e, data) => {
        Components.Forms.setRangeValues(data.sliderValues);

        // $form.submit();
      });

      $.each($inputs, function () {
        let $_this = $(this);
        $_this.off('change.forms').on('change.forms', function (payload) {
          Components.Forms.setRangeValues(payload.sliderValues);
          // $form.submit();
        });
      });

      $(Components.Forms.Selectors.prizesFiltersForm).off('customrange:change').on('customrange:change', (e, data) => {
        console.table(data.sliderValues);
      });
    },

    setRangeValues: val => {
      let $min = $(Components.Forms.Selectors.min);
      let $max = $(Components.Forms.Selectors.max);
      if($min.length || $max.length) {
          let value = val ? val : Components.CustomRange.customrange.noUiSlider.get();
          $min.val(value[0]);
          $max.val(value[1]);
      }
    },

    loadRecaptcha: () => {
      const script = document.createElement('script');
      let form = document.getElementById("registrationForm");
      let action = '';
      if (form) {
        action = 'userCheck';
      } else {
        form = document.getElementById("authenticationForm");
        action = '?action=request'
      }
      const siteKey = form && form.dataset.siteKey;

      if (!siteKey) return;

      script.id = 'recaptcha'
      script.src = `//www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        grecaptcha.ready(function () {
          grecaptcha.execute(siteKey, {action: action}).then(function (token) {
            // Add logic to submit
            const input = document.createElement("input");
            input.setAttribute("type", "hidden");
            input.setAttribute("name", "captchaToken");
            input.setAttribute("value", token);
            form.appendChild(input);
          });
        });
      };
      document.body.appendChild(script);
    },

    init: function () {
      this.loadRecaptcha();
      Components.Forms.bindEvents();
      if ($(Components.Forms.Selectors.prizesFiltersForm).length > 0) {
        Components.Forms.bindPrizesFiltersForm();
      }
    }

  });

})(jQuery,
    window.App,
    window.App.Utils,
    window.App.Components
);